import * as z from "zod";
import { userFacingError } from "../authorization";
import { connectorsByIdentifier } from "../connectors";
import { mutator } from "./mutator";

export const prepareConnectorOAuthClientSchema = z.object({
  connectedAppId: z.string(),
});

export const prepareConnectorOAuthClient = mutator({
  description:
    "Sets up a connector’s OAuth client by discovering its server, without connecting an account.",
  interactionType: "update",
  schema: prepareConnectorOAuthClientSchema,
  resolve: {
    app: { kind: "connectedApp", from: "connectedAppId" },
  },
  permissions: [
    {
      permission: "connected_app:write",
      scopeId: ({ args }) => args.app.id,
    },
  ],
  fn: async ({ tx, args: { app } }) => {
    if (
      connectorsByIdentifier[app.identifier]?.oauth?.clientCredentialsFrom !==
      "dcr"
    ) {
      throw userFacingError("This connector doesn’t discover its OAuth client");
    }
    if (app.oauthConnectionId) {
      await tx.mutate.oauthConnections.update({
        id: app.oauthConnectionId,
        lastError: null,
      });
    }
  },
});
